import * as t from 'io-ts';

const Metadata = t.type({
    tenant: t.string,
    created: t.string,
});

const APIUserCore = t.type({
    first_name: t.string,
    last_name: t.string,
    id: t.string,
    account_id: t.string,
    email: t.union([t.string, t.null]),
    phone_number: t.union([t.string, t.null]),
    preferred_login: t.string,
    group_ids: t.array(t.string),
    preferred_language: t.string,
});

const PatchedUser = t.type({
    first_name: t.string,
    last_name: t.string,
    id: t.string,
    account_id: t.string,
    preferred_language: t.string,
});

type PatchedUser = t.TypeOf<typeof PatchedUser>;

const APIUserOpt = t.partial({
    _links: t.unknown,
    metadata: Metadata,
});

const APIUser = t.intersection([APIUserCore, APIUserOpt]);

type APIUser = t.TypeOf<typeof APIUser>;

const User = t.type({
    firstName: t.string,
    lastName: t.string,
    id: t.string,
    accountId: t.string,
    email: t.union([t.string, t.null]),
    phoneNumber: t.union([t.string, t.null]),
    preferredLogin: t.string,
    groupIds: t.array(t.string),
    preferredLanguage: t.string,
});

type User = t.TypeOf<typeof User>;

const Account = t.type({
    id: t.string,
    name: t.string,
    active: t.boolean,
    lifecycle_state: t.string,
});

type Account = t.TypeOf<typeof Account>;

export { APIUser, User, Account, PatchedUser };
